export default {
  hasAccess(permissionName = '') {
    const permission = localStorage.getItem('permission');
    return JSON.parse(permission).find(obj => obj.name === permissionName);
  },
};
